import { Image } from "react-bootstrap";
import Link from 'next/link';
import {useRouter} from 'next/router';

export default function NavBar({ proInf, profession, screen, voucherCount = 0, reviewsCount, parentPage ="thanh-vien/u" }) {
    const router = useRouter();
    const currentTab = router.query?.t || 'tong-quan';
    function getActiveMenu(menu) {
        return (currentTab == menu ? "active" : "");
    }
    return (
        <div className={"navSetting mb-4 " + screen} style={{
            position: 'sticky',
            top: screen == 'pc-only' ? '81px' : '62px',
            backgroundColor: 'white',
            zIndex: 100
        }}>
            <div className="tab-content">
                <div className="tab-pane active wrap" id="menu1">
                    <ul className="navHistory">
                        <li>
                            <Link href={"/" + parentPage +"/" + profession.id + "?t=tong-quan"}>
                                <a className={getActiveMenu("tong-quan")}>
                                    <Image layout="fill" className="svg" src="/images/icon-home01.svg" alt="" />
                                </a>
                            </Link>
                        </li>
                        <li>
                            <Link href={"/" + parentPage +"/" + profession.id + "?t=bai-viet"}>
                                <a className={getActiveMenu("bai-viet")}>
                                    Bài viết 
                                    {/* <span>{articleCount}</span> */}
                                </a>
                            </Link>
                        </li>
                        {/* <li>
                            <Link href={"/" + parentPage +"/" + profession.id + "?t=hinh-anh"}>
                                <a className={getActiveMenu("hinh-anh")}>
                                    Kho ảnh
                                    <span>{photosCount}</span>
                                </a>
                            </Link>
                        </li> */}
                        {proInf?.is_professional && <li>
                            <Link href={"/" + parentPage +"/" + profession.id + "?t=danh-gia"}>
                                <a className={getActiveMenu("danh-gia")}>
                                    Được đánh giá
                                    {/* <span>{reviewsCount}</span> */}
                                </a>
                            </Link>
                        </li>}
                        {proInf?.is_professional && <li>
                            <Link href={"/" + parentPage +"/" + profession.id + "?t=coupon"}>
                                <a className={getActiveMenu("coupon")}>
                                    Ưu đãi đặc biệt
                                    <span>{voucherCount}</span>
                                </a>
                            </Link>
                        </li>}
                        {/* <li>
                            <Link href={"/" + parentPage +"/" + profession.id + "?t=thao-luan"}>
                                <a className={getActiveMenu("thao-luan")}>
                                    Thảo luận
                                    <span>{threadsCount}</span>
                                </a>
                            </Link>
                        </li> */}
                        <li>
                            <Link href={"/" + parentPage +"/" + profession.id + "?t=so-luu-tru"}>
                                <a className={getActiveMenu("so-luu-tru")} href="#">
                                    Sổ lưu trữ 
                                    {/* <span>{pinsCount}</span> */}
                                </a>
                            </Link>
                        </li>
                        {proInf?.is_professional && <li>
                            <Link href={"/" + parentPage + "/" + profession.id + "?t=gioi-thieu"}>
                                <a className={getActiveMenu("gioi-thieu")}>
                                    Giới thiệu
                                </a>
                            </Link>
                        </li>}
                    </ul>
                </div>
            </div>
        </div>
    );
}